import { useMemo } from 'react';

import usePublishedVideoResources from 'services/general/videoResourcesList';
import useSubscriptions from 'services/general/subscriptionsList';
import { usePortalConfigs } from 'hooks/usePortalConfigs';

import { gateVideoResources } from '../VideoResources/VideoResources.helpers';

// Video resources after member/partner gating. Shared by the Resources page
// (filter-pill availability, result counts) and the webinars section itself.
export const useVisibleVideoResources = () => {
  const { data: videoResources } = usePublishedVideoResources();
  const { config, source } = usePortalConfigs();
  const { isAnyTinyPlus } = useSubscriptions();

  const visibleResources = useMemo(
    () =>
      gateVideoResources(videoResources, {
        source,
        hideUpsells: config.hide_upsells,
        isAnyTinyPlus,
      }),
    [videoResources, source, config.hide_upsells, isAnyTinyPlus],
  );

  return { visibleResources, isAnyTinyPlus };
};
